import logo from "assets/img/logo.png";
import * as React from "react";
import LongPress from "react-long";
import styled from "styled-components";
import { LONG_PRESS_DURATION } from "utils/ConfigLoader";

interface IProps {
  onLongPress(): void;
}

const Container = styled.div`
  position: absolute;
  bottom: 90px;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 2.4vh;
  user-select: none;
`;

const Logo = styled.div`
  height: 30px;
  padding-left: 15px;
  z-index: 9999;
  background-image: url(${logo});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 160px;
  width: 160px;
  user-select: none;
`;

const Wrapper = styled.div`
  user-select: none;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ManageButton = ({ onLongPress }: IProps) => (
  <Container>
    <LongPress time={LONG_PRESS_DURATION} onLongPress={onLongPress}>
      <Wrapper>
        <span>Powered by</span>
        <Logo />
      </Wrapper>
    </LongPress>
  </Container>
);

export default ManageButton;



// WEBPACK FOOTER //
// ./src/components/common/ManageButton/ManageButton.tsx